export default {
  'app.pwa.offline': 'Vous êtes maintenant hors ligne',
  'app.pwa.serviceworker.updated': 'Un nouveau contenu est disponible',
  'app.pwa.serviceworker.updated.hint':
    'Veuillez appuyer sur le bouton "Actualiser" pour recharger la page actuelle',
  'app.pwa.serviceworker.updated.ok': 'Rafraîchir',
};
